import MoVeInMobileFooter from './MoVeInMobileFooter';
export default MoVeInMobileFooter;
